module.exports = __webpack_public_path__ + "img/spread_profile_example_friends.53c8332a.jpg";